import { TEXT_LENGTH_ERROR } from '@/constants/error';

const Checkpoint = {
  generate() {
    return {
      id: null,
      result: '',
      date: null,
      noMatter: false,
    };
  },
  rulesBlock(checkpoint = undefined) {
    const rules = {
      type: 'object',
      required: true,
      fields: {
        result: {
          required: true,
          min: 2,
          max: 5000,
          message: TEXT_LENGTH_ERROR,
          trigger: 'change',
        },
        date: {
          required: true,
          message: 'Необходимо указать дату выполнения',
          trigger: 'change',
        },
        noMatter: {
          type: 'boolean',
        },
      },
    };

    if (undefined === checkpoint) {
      return rules;
    }

    rules.fields.date.required = !checkpoint.noMatter;

    return rules;
  }
};

export { Checkpoint };